import { TEntityMilestone, TFeatureWorkflowInstance } from "entity-app/models";
import { InputEditDataType } from "popups/rename-model/rename-popup";
import { EditOutlined } from "@ant-design/icons";
import { getDaysText } from "utils/utils";
import { FeatureTypes } from "entity-app/constants";
import { EWorkflowStatusDataBlock } from "../../../../../constants";
import {
  TDateBlockMode,
  TDateBlockPermissions,
  TWidthCalculation
} from "../../models";

export default function TimelineDurations(props: {
  milestones: Array<TEntityMilestone>;
  featureWorkflowInstance: TFeatureWorkflowInstance;
  widthCal: TWidthCalculation;
  setIsRenameModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setRenameDataInput: React.Dispatch<React.SetStateAction<InputEditDataType>>;
  showFloat: boolean;
  permissions: TDateBlockPermissions;
  dateBlockMode?: TDateBlockMode;
}) {
  const {
    milestones,
    featureWorkflowInstance,
    widthCal,
    setIsRenameModalOpen,
    setRenameDataInput,
    showFloat,
    permissions,
    dateBlockMode = "projected"
  } = props;
  const isCommittedMode = dateBlockMode !== "projected";
  const hideOffsetName =
    featureWorkflowInstance.feature_type_id === FeatureTypes.DESIGN_PACKAGE;

  const isWorkflowStarted =
    (featureWorkflowInstance.workflow_status as string) !==
    (EWorkflowStatusDataBlock.WF_NOT_STARTED as string);

  const floatBlock = showFloat ? (
    <div
      key={`Float_${featureWorkflowInstance.id}`}
      className="flex items-end justify-end text-xs space-y-1 font-semibold"
      style={{ width: widthCal.lastLineWidth + 60 }}
      data-testid="timeline-durations-float-block"
    >
      <div className="flex flex-col items-center ">
        <div data-testid="timeline-durations-float-label">Float &</div>
        <div data-testid="timeline-durations-deadline-label">Deadline</div>
      </div>
    </div>
  ) : null;

  const { length: countMilestones } = milestones;

  return (
    <div className="flex h-10 pl-[70px]" data-testid="timeline-durations-root">
      {milestones.map((m, index) => {
        if (!m.feature_workflow_instance_offsets_as_src.length)
          return countMilestones - 1 === index ? (
            floatBlock
          ) : (
            <div
              className="w-14"
              key={`TimelineDurations_${m.id}`}
              data-testid={`timeline-durations-empty-block-${m.id}`}
            />
          );
        const offset = m.feature_workflow_instance_offsets_as_src[0];
        return (
          <div
            key={`TimelineDurations_block_${m.id}`}
            className="flex "
            data-testid={`timeline-durations-milestone-block-${m.id}`}
          >
            {countMilestones - 1 === index && floatBlock}
            <div
              key={`TimelineDurations_${m.id}`}
              className="flex flex-col items-center text-xs space-y-1 font-semibold"
              style={{ width: widthCal.timelineWidth }}
              data-testid={`timeline-durations-milestone-inner-${m.id}`}
            >
              <div data-testid={`timeline-durations-offset-name-${offset.id}`}>
                {hideOffsetName ? " " : offset.name}
              </div>
              <div
                className="flex space-x-1 items-center"
                data-testid={`timeline-durations-duration-row-${offset.id}`}
              >
                <div
                  data-testid={`timeline-durations-duration-value-${offset.id}`}
                >
                  {isCommittedMode && offset.duration == null ? (
                    <span className="text-gray-400">–</span>
                  ) : (
                    `(${offset.duration} ${getDaysText(offset.duration)})`
                  )}
                </div>

                {permissions.canEditDurations && offset.is_editable && (
                  <EditOutlined
                    className="pl-1"
                    data-testid={`timeline-durations-edit-icon-${offset.id}`}
                    onClick={() => {
                      setRenameDataInput({
                        value: offset.duration,
                        id: offset.id,
                        lable: offset.name,
                        type: "text",
                        identityName: "WorkflowInstanceOffset",
                        warningMessage: isWorkflowStarted
                          ? "Editing this duration will change the planned dates of the subsequent milestones. Are you sure you want to proceed?"
                          : undefined
                      });
                      setIsRenameModalOpen(true);
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
